import { View, StyleSheet, TouchableOpacity, Dimensions, Animated, PanResponder, Image, Platform } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import TypographyDLSBase from "../../typography/TypographyDLS.base";
import { ColorTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from "@voltmoney/schema";
import Icon from "../../icon/Icon";
import AnimatedModal from "./AnimatedModal";
import { isMobileView } from "../../stack/utils";
import { showRMDetails } from "../utils";
const RmContactList = ({ title, containerWidth, handleRmConnection, rmData, triggerAction, }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const isDragging = useRef(false);
    const pan = useRef(new Animated.ValueXY()).current;
    const screenWidth = Dimensions.get('window').width;
    const screenHeight = Dimensions.get('window').height;
    const [showRM, setShowRM] = useState(showRMDetails());
    useEffect(() => {
        const handleTouchMove = (event) => {
            if (isDragging.current) {
                event.preventDefault();
            }
        };
        if (Platform.OS === 'web') {
            window.addEventListener('touchmove', handleTouchMove, { passive: false });
            return () => {
                window.removeEventListener('touchmove', handleTouchMove);
            };
        }
    }, []);
    const panResponder = useRef(PanResponder.create({
        onMoveShouldSetPanResponder: () => true,
        onStartShouldSetPanResponder: () => true,
        onPanResponderGrant: () => {
            isDragging.current = true;
        },
        onPanResponderMove: Animated.event([null, { dx: pan.x, dy: pan.y }]),
        onPanResponderRelease: (evt, gestureState) => {
            isDragging.current = false;
            if (gestureState.moveY > (screenHeight - 90) || gestureState.moveX > (screenWidth - 50) || gestureState.moveY < 40 || gestureState.moveX < 40) {
                Animated.spring(pan, {
                    toValue: { x: 0, y: 0 },
                    useNativeDriver: false,
                }).start();
            }
            else
                pan.extractOffset();
        },
    })).current;
    const handleOpenModal = () => {
        setModalVisible(true);
    };
    const handleCloseModal = () => {
        setModalVisible(false);
    };
    const handleLongPress = (e) => {
        e.preventDefault();
    };
    return showRM ? (React.createElement(View, { style: [styles.container] },
        !modalVisible && !isMobileView() && React.createElement(TouchableOpacity, { style: styles.buttonContent, onPress: handleOpenModal },
            React.createElement(View, { style: { width: 40, height: 40, backgroundColor: 'white', alignItems: 'center', justifyContent: 'center', borderRadius: 1000 } },
                (rmData?.isRelationshipManagerPresent && rmData?.profileImageURL !== null) && (React.createElement(View, { style: { backgroundColor: '#F1F3F5', borderRadius: 1000 } },
                    React.createElement(Image, { source: { uri: rmData?.profileImageURL !== null ? rmData?.profileImageURL : "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Mask+group.png" }, style: { width: 40, height: 40, borderRadius: 1000 } }))),
                (!rmData?.isRelationshipManagerPresent || rmData?.profileImageURL === null) && React.createElement(Icon, { name: IconTokens.SYSTEM_SUPPORT_DLS, size: IconSizeTokens.XXL, color: ColorTokens.Primary_100 })),
            React.createElement(View, { style: { marginLeft: 8 } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B0B, label: rmData?.isRelationshipManagerPresent ? "Contact RM" : "Contact us", color: ColorTokens.White }))),
        !modalVisible && isMobileView() && (React.createElement(Animated.View, { style: {
                transform: [{ translateX: pan.x }, { translateY: pan.y }],
            }, ...panResponder.panHandlers },
            React.createElement(TouchableOpacity, { onPress: handleOpenModal, onLongPress: handleLongPress },
                React.createElement(View, { style: styles.iconContainer },
                    rmData?.isRelationshipManagerPresent && rmData?.profileImageURL !== null && (React.createElement(View, { style: { backgroundColor: '#F1F3F5', borderRadius: 1000 } },
                        React.createElement(Image, { source: { uri: rmData?.profileImageURL !== null ? rmData?.profileImageURL : "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/support.png" }, style: { width: 46, height: 46, borderRadius: 1000 } }))),
                    (!rmData?.isRelationshipManagerPresent || rmData?.profileImageURL === null) && React.createElement(Icon, { name: IconTokens.SYSTEM_SUPPORT_DLS, size: IconSizeTokens.XXL, color: ColorTokens.Primary_100 }))))),
        React.createElement(AnimatedModal, { visible: modalVisible, onClose: handleCloseModal, handleConnection: handleRmConnection, triggerAction: triggerAction, rmData: rmData }))) : (React.createElement(React.Fragment, null));
};
const styles = StyleSheet.create({
    container: {
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        position: "absolute",
        ...!isMobileView() && {
            backgroundColor: '#1434CB',
        },
        borderRadius: 1000,
        bottom: isMobileView() ? 10 : 20,
        right: isMobileView() ? 10 : 20
    },
    buttonContent: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: 8,
        paddingVertical: 8,
        paddingRight: 20
    },
    iconContainer: {
        width: 56,
        height: 56,
        backgroundColor: 'white',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 1000,
        zIndex: 1,
        right: 10,
        bottom: 10,
        borderColor: '#1434CB',
        borderWidth: 4,
    },
});
export default RmContactList;
